import { httpBatchLink, httpLink } from '@trpc/client';
import superjson from 'superjson';

import type { GetExtraHeaders } from './createMainServiceTrpcClient';

interface BuildHttpLinkOptions {
  url: string;
  getExtraHeaders?: GetExtraHeaders;
  fetch?: typeof fetch;
}

interface BuildHttpBatchLinkOptions extends BuildHttpLinkOptions {
  maxItems: number;
}

function buildFetch({
  getExtraHeaders,
  fetch: customFetch,
}: BuildHttpLinkOptions) {
  return (fetchUrl: URL | RequestInfo, options?: RequestInit) => {
    const headers = new Headers(options?.headers ?? {});

    const extraHeaders = getExtraHeaders?.();
    if (extraHeaders) {
      new Headers(extraHeaders).forEach((value, key) => {
        headers.set(key, value);
      });
    }

    return (customFetch ?? fetch)(fetchUrl, {
      ...(options as RequestInit),
      headers,
      credentials: 'include',
    });
  };
}

/**
 * Creates an `httpLink` configured with superjson, `credentials: 'include'`
 * and optional extra headers injection.
 */
export function buildHttpLink(options: BuildHttpLinkOptions) {
  return httpLink({
    url: options.url,
    transformer: superjson,
    fetch: buildFetch(options),
  });
}

/**
 * Creates an `httpBatchLink` configured with superjson, `credentials: 'include'`
 * and optional extra headers injection.
 */
export function buildHttpBatchLink(options: BuildHttpBatchLinkOptions) {
  return httpBatchLink({
    url: options.url,
    maxItems: options.maxItems,
    transformer: superjson,
    fetch: buildFetch(options),
  });
}
